import { APP_BASE_HREF, DOCUMENT } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideNgxMask } from 'ngx-mask';
import { NgProgressComponent } from 'ngx-progressbar';
import { MessageService } from 'primeng/api';

import { AccessModule } from '../access/access.module';
import { AnalyticsModule } from '../analytics/analytics.module';
import { ApiModule } from '../api/api.module';
import { ReloadListService } from '../list/services/reload-list.service';
import { MonitoringModule } from '../monitoring/monitoring.module';
import { AppComponent } from './components/app/app.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { TopbarComponent } from './components/topbar/topbar.component';
import { MainDirectiveModule } from './directive/main-directive.module';
import { MainRoutingModule } from './main-routing.module';
import { MainSharedModule } from './main-shared.module';
import { MessageParseService } from './services/message-parse-service';

@NgModule({
    declarations: [AppComponent, DashboardComponent, SidebarComponent, TopbarComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AnalyticsModule,
        MonitoringModule,
        HttpClientModule,
        MainRoutingModule,
        ApiModule,
        AccessModule,
        MainSharedModule,
        MainDirectiveModule,
        NgProgressComponent,
    ],
    providers: [
        MessageService,
        MessageParseService,
        ReloadListService,
        provideNgxMask(),
        { provide: Window, useValue: window },
        {
            provide: APP_BASE_HREF,
            useFactory: (doc: Document) => doc.querySelector('base')?.getAttribute('href') || '/',
            deps: [DOCUMENT],
        },
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class AppModule {}
